import { CompilerStatusIcon } from './CompilerStatusIcon'
import { FaIcon, FaIconProps } from './FaIcon'

type StatusIconProps = Omit<FaIconProps, 'color' | 'icon'>

// TODO: Export components individually, preserving callers, in a follow-up.
// These existing compound exports are retained for the Oxlint 1.86 upgrade.
// oxlint-disable-next-line react/only-export-components
const Success = (props: StatusIconProps) => (
  <FaIcon icon="fa-circle-check" color="green.7" {...props} />
)

// oxlint-disable-next-line react/only-export-components
const Error = (props: StatusIconProps) => (
  <CompilerStatusIcon type="error" {...props} />
)

// oxlint-disable-next-line react/only-export-components
const Warning = (props: StatusIconProps) => (
  <CompilerStatusIcon type="warning" {...props} />
)

// oxlint-disable-next-line react/only-export-components
const ToDo = (props: StatusIconProps) => (
  <CompilerStatusIcon type="todo" {...props} />
)

const InkStatusIcon = {
  Success,
  Warning,
  Error,
  ToDo,
}

export default InkStatusIcon
